(()=>{if(matchMedia('(prefers-reduced-motion: reduce)').matches||!('IntersectionObserver'in window))return;const o=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('markiewka-reveal');o.unobserve(e.target)}}),{threshold:.12});document.querySelectorAll('#MainContent .shopify-section,product-card').forEach(e=>o.observe(e));})();
function initializeMarkiewkaBestsellers() {
  document.querySelectorAll('[data-mk-bestsellers]').forEach(function(section) {
    if (section.dataset.mkReady) return;
    section.dataset.mkReady = 'true';
    const track = section.querySelector('.mk-best-track');
    section.addEventListener('click', function(event) {
      const previous = event.target.closest('[data-mk-best-prev]');
      const next = event.target.closest('[data-mk-best-next]');
      if (previous || next) {
        track.scrollBy({left:(previous ? -1 : 1)*track.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }
    });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeMarkiewkaBestsellers);
else initializeMarkiewkaBestsellers();
document.addEventListener('shopify:section:load', initializeMarkiewkaBestsellers);